import { render, staticRenderFns } from "./achievementChange.vue?vue&type=template&id=652a8284"
import script from "./achievementChange.vue?vue&type=script&lang=js"
export * from "./achievementChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports